import { FORMAT_OPTION } from '../format-options.service'
import { ALIGN, CELL_FORMAT_TYPE } from './table-edit.constants'

class CellFormatEditService {
  updateCellFormatPart (cellFormatParts = [], index, updates) {
    cellFormatParts = [ ...cellFormatParts ]
    const isNewFormat = updates.format && (!cellFormatParts[index] || cellFormatParts[index].format !== updates.format)

    // When updating secondary before primary is created, create a blank primary config
    if (index === 1 && !cellFormatParts[0]) {
      cellFormatParts[0] = {}
    }

    // Apply updates to a copy
    cellFormatParts[index] = { ...(cellFormatParts[index] || {}), ...updates }

    if (isNewFormat) {
      cellFormatParts = this.applyConfigDefaults(cellFormatParts, index)
      cellFormatParts = this.updateCellFormatAlignment(cellFormatParts)

      // When switching from a format that supports more variables to one with less, trim off the unsupported variables
      if (cellFormatParts[index].variables !== undefined) {
        if ([CELL_FORMAT_TYPE.PERCENT_BAR, CELL_FORMAT_TYPE.TEXT].includes(cellFormatParts[index].format)) {
          cellFormatParts[index].variables = cellFormatParts[index].variables.slice(0, 1)
        } else if (cellFormatParts[index].format === CELL_FORMAT_TYPE.NUMBER) {
          cellFormatParts[index].variables = cellFormatParts[index].variables.slice(0, 2)
        }
      }

      // Delete unnecessary config settings when switching format
      if (cellFormatParts[index].format !== CELL_FORMAT_TYPE.CONFIDENCE) {
        delete cellFormatParts[index].referenceline
      }
    }

    return cellFormatParts
  }

  removeCellFormatPart (cellFormatParts = [], index) {
    cellFormatParts = [ ...cellFormatParts ]

    if (index === 0 && cellFormatParts.length > 1) {
      cellFormatParts[0] = {}
    } else if (index === 0) {
      cellFormatParts = []
    }

    if (index === 1) {
      cellFormatParts.splice(1, 1)
    }

    // Adjust alignment when removing cell format configs
    cellFormatParts = this.updateCellFormatAlignment(cellFormatParts)

    return cellFormatParts
  }

  applyConfigDefaults (cellFormatParts, index) {
    const cellFormatConfig = cellFormatParts[index]

    const defaultConfig = {}
    if (cellFormatConfig.format === CELL_FORMAT_TYPE.NUMBER) {
      defaultConfig.type = FORMAT_OPTION.NUMBER
      if (index === 1) {
        defaultConfig.parens = true
        defaultConfig.join = ', '
      }
    }
    if (cellFormatConfig.format === CELL_FORMAT_TYPE.CONFIDENCE) {
      defaultConfig.referenceline = 0
    }

    if (Object.keys(defaultConfig).length > 0) {
      cellFormatParts = [ ...cellFormatParts ]
      cellFormatParts[index] = { ...defaultConfig, ...cellFormatParts[index] }
    }

    return cellFormatParts
  }

  updateCellFormatAlignment (cellFormatParts = []) {
    // Set center alignment if just primary
    if (cellFormatParts.length === 1 && cellFormatParts[0].align !== ALIGN.CENTER) {
      cellFormatParts = [ ...cellFormatParts ]
      cellFormatParts[0] = { ...cellFormatParts[0], align: ALIGN.CENTER }
    }

    // Set right aligned primary & left aligned secondary if both values exist
    if (cellFormatParts.length === 2 && (cellFormatParts[0].align !== ALIGN.RIGHT || cellFormatParts[1].align !== ALIGN.LEFT)) {
      cellFormatParts = [ ...cellFormatParts ]
      cellFormatParts[0] = { ...cellFormatParts[0], align: ALIGN.RIGHT }
      cellFormatParts[1] = { ...cellFormatParts[1], align: ALIGN.LEFT }
    }

    return cellFormatParts
  }

  buildInitialCellFormats (cellFormatKeys) {
    const cellFormats = {}
    cellFormatKeys.forEach((key) => {
      cellFormats[key] = []
    })
    return cellFormats
  }
}

export const cellFormatEditService = new CellFormatEditService()
